import React, {createContext, useContext} from 'react';
import usePresScale from '../ui/util/usePresScale';

type PresScaleValue = ReturnType<typeof usePresScale>;

const PresScaleContext = createContext<PresScaleValue | null>(null);

export function PresScaleProvider({children}: {children: React.ReactNode}): JSX.Element {
    const value = usePresScale();
    return <PresScaleContext.Provider value={value}>{children}</PresScaleContext.Provider>;
}

export function usePresScaleContext(): PresScaleValue {
    const ctx = useContext(PresScaleContext);
    if (!ctx) throw new Error('usePresScaleContext must be used inside a PresScaleProvider');
    return ctx;
}

/** Returns null when rendered outside PresScaleProvider (e.g. theme preview). */
export function useOptionalPresScaleContext(): PresScaleValue | null {
    return useContext(PresScaleContext);
}
